import BaseResource from './index'
import UnionAdminLocalResource from './unionAdminLocal'
import UnionLocationConditionHiredResource from './unionLocationConditionHired'
import UnionLocationConditionWorkResource from './unionLocationConditionWork'

export default class UnionLocationConditionsResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/unionLocationConditions'
    static related() {
        return {
            union_local_id: UnionAdminLocalResource,
            hired_from_ids: UnionLocationConditionHiredResource,
            working_in_ids: UnionLocationConditionWorkResource,
        }
    }
}
